// extracted by mini-css-extract-plugin
export default {"section":"ProjectListing_section__Q2ERi","total":"ProjectListing_total__0yb1N"};